import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';

import FormSelectField, { toOptions } from './FormSelectField';

interface IconOption {
  value: string;
  label: string;
  color?: string;
}

interface IFormSelectWithIconFieldProps {
  label?: string;
  options: string[] | IconOption[];
  defaultValue?: string;
  onChange: (value: string) => void;
  id?: string;
  innerRef?: React.RefObject<HTMLInputElement> | ((el: HTMLDivElement) => void);
  styles?: React.CSSProperties | Record<string, React.CSSProperties>;
  error?: string;
  required?: boolean;
  isDisabled?: boolean;
}

const FormSelectWithIconField = ({ options, ...props }: IFormSelectWithIconFieldProps) => (
  <FormSelectField
    {...props}
    options={typeof options[0] === 'string' ? toOptions(options as string[]) : options}
    renderAdornment={(option) =>
      'color' in option && option.color ? (
        <CircleIcon sx={{ marginLeft: '10px', fontSize: '12px', color: option.color }} />
      ) : null
    }
  />
);

export default FormSelectWithIconField;
